"use client"

import { NpActivateCouponRegion } from "src/components/np-design/components/NpActivateCouponRegion"
import { useProductContext } from "../context"

export const ProductActivateCouponCode = () => {
  const { resolvedCoupon: productCoupon } = useProductContext()

  if (!productCoupon) {
    return null
  }

  return <NpActivateCouponRegion code={productCoupon.code} amountSaved={productCoupon.text} />
}
